import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'

export const AddNewToken = ({ onClick }) => {
  return (
    <BusyButton
      {...{
        icon: 'plus',
        text: 'Add new...',
        onClick,
        title: 'Add new personal access token...',
      }}
    />
  )
}
